export default __webpack_public_path__ + "static/media/explore-tablet-7.aa8409ee.png";